import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {goToPage, updateDocumentTitle} from "../../Utils/Common";
import {useHistory} from "react-router-dom";
import PageLayout from "../Layout/PageLayout";
import {Card, CardTitleBar, CardBody, FormField, TextInput, Select, Button} from "../UI";
import {tokens} from "../../theme/tokens";

const NewRider = props => {

    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [idNumber, setIDNumber] = useState('');
    const [vehicleRegNo, setVehicleRegNo] = useState('');
    const [areaID, setAreaID] = useState('');
    const [regionID, setRegionID] = useState('');
    const [regionList, setRegionList] = useState([]);
    const [areaList, setAreaList] = useState([]);

    useEffect(() => {
        updateDocumentTitle("Add new rider")
        loadAreas()
    }, []);

    const submitForm = e => {
        e.preventDefault();

        let data = new FormData();
        data.append("name", name)
        data.append("email", email)
        data.append("phone", phone)
        data.append("id_number", idNumber)
        data.append("reg_no", vehicleRegNo)
        data.append("area_id", areaID)
        data.append("region_id", regionID)

        setIsLoading(true);

        postData(Endpoints.RIDER_ADD, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setName('');
                    Notify(res.data, SUCCESS);
                    goToPage(history, "/riders")
                } else {
                    if (Array.isArray(res.message)) {
                        Notify(res.message[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }


    function loadAreas() {
        let data = new FormData();
        data.append("status", 1);
        setIsLoading(true)
        postData(Endpoints.AREA_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setAreaList(res.data || []);
                    if (res.data.length > 0) {
                        setAreaID(res.data[0].id)
                        loadRegions(res.data[0].id)
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    function loadRegions(id) {
        let data = new FormData();
        data.append("area_id", id);
        data.append("status", 1);
        setIsLoading(true)
        postData(Endpoints.REGION_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setRegionList(res.data || []);
                    if (res.data.length > 0) setRegionID(res.data[0].id)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }


    return (
        <PageLayout
            title="Add a new rider"
            actions={
                <Link to="/riders">
                    <Button variant="outline">Back to riders</Button>
                </Link>
            }
        >
            <Card padded={false} style={{maxWidth: 620}}>
                <CardTitleBar title="Enter new rider details"/>
                <CardBody>
                    <form onSubmit={submitForm}>

                        <FormField label="Full name">
                            <TextInput type="text"
                                       required
                                       value={name}
                                       onChange={e => setName(e.target.value)}
                            />
                        </FormField>

                        <FormField label="Email">
                            <TextInput type="text"
                                       required
                                       value={email}
                                       onChange={e => setEmail(e.target.value)}
                            />
                        </FormField>

                        <FormField label="Phone number">
                            <TextInput type="text"
                                       required
                                       value={phone}
                                       onChange={e => setPhone(e.target.value)}
                            />
                        </FormField>

                        <FormField label="Vehicle registration number">
                            <TextInput type="text"
                                       required
                                       value={vehicleRegNo}
                                       onChange={e => setVehicleRegNo(e.target.value)}
                            />
                        </FormField>

                        <FormField label="Select area">
                            <Select value={areaID}
                                    onChange={({target}) => {
                                        setAreaID(target.value)
                                        loadRegions(target.value)
                                    }}>
                                {areaList.map((i, k) => <option
                                    value={i.id}>{i.title}</option>
                                )}
                            </Select>
                        </FormField>

                        <FormField label="Select region">
                            <Select value={regionID}
                                    onChange={({target}) => setRegionID(target.value)}>
                                {regionList.map((i, k) => <option
                                    value={i.id}>{i.title}</option>
                                )}
                            </Select>
                        </FormField>

                        <p style={{margin: `0 0 ${tokens.spacing[4]}`, color: tokens.colors.muted, fontSize: tokens.typography.size.sm}}>
                            *They will receive their login PIN via SMS
                        </p>

                        <Button type="submit" loading={isLoading}>Create</Button>

                    </form>
                </CardBody>
            </Card>
        </PageLayout>
    )
};

export default NewRider;
